import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiCacheTags } from "common/models";

export class ApiBaseError<TValue = any> {
  status?: number;

  data?: string[];

  value?: TValue;

  constructor(status?: number, data?: string[], value?: TValue) {
    this.status = status;
    this.data = data;
    this.value = value;
  }
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fakeBaseQuery<ApiBaseError>(),
  tagTypes: Object.values(ApiCacheTags),
  endpoints: () => ({}),
  keepUnusedDataFor: 0
});

export const { middleware, reducer, reducerPath } = baseApi;
